@if (teamCalc) {
  <mat-card class="mat-elevation-z3 no-content-padding">
    <mat-card-content>
      <dt-team-dashboard-objective-weights-table
        [team]="team"
        [teamCalc]="teamCalc"
        (valuesChanged)="recalc()"
      ></dt-team-dashboard-objective-weights-table>
    </mat-card-content>
  </mat-card>
  <mat-card class="mat-elevation-z3">
    <mat-card-content>
      <dt-team-dashboard-objective-weights-graph [team]="team" [teamCalc]="teamCalc"></dt-team-dashboard-objective-weights-graph>
    </mat-card-content>
  </mat-card>
}

@if (!teamCalc && !errored) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
@if (errored) {
  <h3 i18n>Es ist ein Fehler aufgetreten. Bitte versuche es später erneut.</h3>
}
